import React, { useEffect, useState } from 'react';
import { mediaUrl } from '../utils/mediaUrl';
import { Link, useLocation, useParams } from 'react-router-dom';
import { getMyOrders } from '../services/orderService';
import ReviewForm from '../components/review/ReviewForm';
import { trackPurchase } from '../utils/analytics';
import '../css/orderSuccess.css';

const OrderSuccessPage = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order || null);
  const [loading, setLoading] = useState(true);

  // ---------- review modal state ----------
  const [reviewItem, setReviewItem] = useState(null); // item being reviewed
  const [reviewedIds, setReviewedIds] = useState([]); // products already reviewed in this session

  useEffect(() => {
    // Checkout passes the order in navigation state; on refresh we look it
    // up in the customer's own orders (public tracking needs a phone number).
    const fetchOrder = async () => {
      if (location.state?.order) {
        setLoading(false);
        return;
      }
      try {
        const mine = await getMyOrders();
        setOrder((mine || []).find((o) => o.orderId === orderId || o._id === orderId) || null);
      } catch (error) {
        console.error('Failed to fetch order details:', error);
      } finally {
        setLoading(false);
      }
    };

    
    if (orderId) {
      fetchOrder();
    }
  }, [orderId, location.state]);

  // analytics: purchase (sent once per order)
  useEffect(() => {
    if (order) trackPurchase(order);
  }, [order]);

  const openReview = (item) => setReviewItem(item);
  const closeReview = () => setReviewItem(null);

  if (loading) {
    return (
      <div className="order-success-page">
        <p>Loading order details...</p>
      </div>
    );
  }

  return (
    <div className="order-success-page">
      <img
        src="https://assets-v2.lottiefiles.com/a/6192c96c-1184-11ee-94d6-87985660cc3b/eKofKHrW1u.gif"
        alt="Order Success"
        className="success-image"
      />
      <h1>Order Placed</h1>
      <p>Your order ID is {orderId}</p>

      <div className="success-actions">
        <Link to="/account" state={{ activeTab: 'orders' }} className="btn-view-orders">
          View Orders
        </Link>
      </div>

      {/* ---------- review your items ---------- */}
      {order?.orderItems?.length > 0 && (
        <div className="review-items-section">
          <h2>Rate your items</h2>
          <p className="review-items-hint">Share your experience with other shoppers</p>

          <div className="review-items-list">
            {order.orderItems.map((item) => {
              const productId = item.product?._id || item.product; // handle populated or plain id
              const alreadyReviewed = reviewedIds.includes(productId);
              return (
                <div className="review-item-card" key={productId + (item.size || '')}>
                  {item.image && (
                    <img src={mediaUrl(item.image)} alt={item.name} className="review-item-img" />
                  )}
                  <div className="review-item-info">
                    <span className="review-item-name">{item.name}</span>
                    {item.size && <span className="review-item-meta">Size: {item.size}</span>}
                  </div>
                  <button
                    className="btn-write-review"
                    disabled={alreadyReviewed}
                    onClick={() => openReview({ ...item, product: productId })}
                  >
                    {alreadyReviewed ? '✓ Reviewed' : '⭐ Write Review'}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ---------- review modal ---------- */}
      {reviewItem && (
        <ReviewForm
          productId={reviewItem.product?._id || reviewItem.product}
          productName={reviewItem.name}
          onClose={closeReview}
          onSubmitted={(pid) => setReviewedIds((prev) => [...prev, pid])}
        />
      )}
    </div>
  );
};

export default OrderSuccessPage;